import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@ribera-web/app-token';
import { LoginAdminRequestDto, ILoginSuccessResponse, UserLoginData } from '../models/auth.models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthAdminApiService {

  private http = inject(HttpClient);
  private config = inject(APP_CONFIG);

  private apiUrlSecurity = this.config.SECURITY_MICROSERVICE_API + '/api/v2/admin';

  login(request: LoginAdminRequestDto): Observable<ILoginSuccessResponse> {
    return this.http.post<ILoginSuccessResponse>(
      `${this.apiUrlSecurity}/auth/login`,request);
  }

  refreshToken(): Observable<ILoginSuccessResponse>{
    return this.http.post<ILoginSuccessResponse>(`${this.apiUrlSecurity}/auth/refresh`, {}, { withCredentials: true });
  }

  getUserLoginData(): Observable<UserLoginData> {
    return this.http.get<UserLoginData>(`${this.apiUrlSecurity}/auth/me`);
  }
  
}
